import { formattedCents } from "source/giving/utils/money"

export function PaneWrapper({ children }: { children: React.ReactNode }) {
  return <div className="d-f jc-sb my-3">{children}</div>
}

export function ContinueAuthedDisplay({
  totalCents,
  onClick,
}: {
  totalCents: number
  onClick: () => void
}) {
  return (
    <button className="btn" onClick={onClick}>
      Continue to give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
    </button>
  )
}

export function FormSubmitDisplay({
  handleSubmit,
  totalCents,
}: {
  handleSubmit: () => void
  totalCents: number
}) {
  return (
    <button className="btn" onClick={handleSubmit}>
      Give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
    </button>
  )
}
